import type { ILendingLimitLoan, ILendingLimitSearch } from '@apply/api/src/api/LendingLimitApi';
import type { LoanProduct, LoanRecord, SummaryInput } from '@apply/lending-limits';

/**
 * Maps the BE lending-limit response into the calc package's {@link SummaryInput}.
 *
 * One borrower entity → one "borrower" (one workbook `Borrower N` tab).
 */
function mapLoan(loan: ILendingLimitLoan): LoanRecord {
    return {
        loanNumber: loan.loanNumber,
        bfiNumber: loan.bfiNumber,
        loanType: loan.loanType,
        commitmentAmount: loan.commitmentAmount,
        outstandingBalance: loan.outstandingBalance,
        repaidAmount: loan.repaidAmount,
        isOutstanding: loan.isOutstanding,
        repaymentDate: loan.repaymentDate ? new Date(loan.repaymentDate) : null,
        principalPaymentReceived: loan.principalPaymentReceived,
        ytdInterestPaid: loan.ytdInterestPaid,
        financedBfiFees: loan.financedBfiFees,
        ltv: loan.ltv,
        appraisedValue: loan.appraisedValue,
    };
}

export function mapResponseToSummaryInput(response: ILendingLimitSearch): SummaryInput {
    return {
        borrowers: response.borrowerEntities.map((entity) => ({
            name: entity.name,
            product: entity.product as LoanProduct,
            builtSince2011: entity.builtSince2011,
            gcBonus: entity.gcBonus,
            loans: entity.loans.map(mapLoan),
        })),
    };
}
